"use client";

import CloseIcon from "@mui/icons-material/Close";
import { Box, Dialog, DialogTitle, IconButton, Typography } from "@mui/material";
import type React from "react";
import type { Information } from "@/shared/lib/api/api-client";
import InformationView from "./InformationView";

interface InformationDetailDialogProps {
	open: boolean;
	info: Information | null;
	onClose: () => void;
}

export default function InformationDetailDialog({
	open,
	info,
	onClose,
}: InformationDetailDialogProps): React.ReactElement {
	if (!info) return <div />;

	return (
		<Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
			<DialogTitle sx={{ m: 0, p: 2, display: "flex", alignItems: "center" }}>
				<Typography variant="h6" sx={{ fontWeight: "bold" }}>
					プレビュー
				</Typography>
				<Box sx={{ flex: 1 }} />
				<IconButton
					aria-label="close"
					onClick={onClose}
					sx={{
						color: (theme) => theme.palette.grey[500],
					}}
				>
					<CloseIcon />
				</IconButton>
			</DialogTitle>
			<Box sx={{ display: "flex", justifyContent: "center", pb: 3 }}>
				<InformationView jsonContents={[info]} />
			</Box>
		</Dialog>
	);
}
